// import React from "react";
// import ReactDOM from "react-dom";
// // import dotEnv from "dotenv";
// import reportWebVitals from "./reportWebVitals";
// import App from "./app/App";
// import "./assets/styles/styles.scss";

// // dotEnv.config();

// ReactDOM.render(<App />, document.getElementById("root"));
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Include in the main bundle so lazy routes don’t fetch a separate chunk that can 404 after
// dev-server rebuilds (ChunkLoadError: Loading chunk … TablePagination … failed).
import '@material-ui/core/TablePagination';
import App from "./app/App";
import reportWebVitals from './reportWebVitals';
import "./assets/styles/styles.scss";
import { Toaster } from './components/ui/toaster';
import { BrowserRouter as Router } from "react-router-dom";
import { TourProvider } from './components/ui/TourContext';

const CHUNK_RETRY_KEY = 'pt_chunk_reload_once';

/** Recover from stale webpack chunk URLs (common after `npm start` / HMR / new deploy). */
function installChunkLoadRecovery() {
  if (typeof window === 'undefined') return;

  const isChunkFailure = (err) => {
    const msg = err?.message || err?.toString?.() || '';
    return (
      err?.name === 'ChunkLoadError' ||
      /Loading chunk [\w-]+ failed/i.test(msg) ||
      /ChunkLoadError/i.test(msg)
    );
  };

  const tryReload = () => {
    if (sessionStorage.getItem(CHUNK_RETRY_KEY)) return;
    sessionStorage.setItem(CHUNK_RETRY_KEY, '1');
    window.location.reload();
  };

  window.addEventListener(
    'error',
    (event) => {
      if (isChunkFailure(event?.error)) tryReload();
    },
    true
  );

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkFailure(event?.reason)) tryReload();
  });

  // Allow a future auto-retry after a successful load (new deploy / cache clear).
  window.addEventListener('load', () => {
    setTimeout(() => sessionStorage.removeItem(CHUNK_RETRY_KEY), 8000);
  });
}

installChunkLoadRecovery();

const root = ReactDOM.createRoot(document.getElementById('root'));
const prefersDark = localStorage.getItem("darkMode") === "true";
if (prefersDark) {
  document.documentElement.classList.add("dark");
} else {
  document.documentElement.classList.remove("dark");
}
root.render(
   <Router> 
  <React.StrictMode>
    <TourProvider>
    <Toaster />
      <App />
    </TourProvider>
  </React.StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
